"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var createEditorViewState_1 = require("owa-editor/lib/utils/createEditorViewState");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_session_store_1 = require("owa-session-store");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('discardSignatureOption')(function discardSignatureOption(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    optionState.editorViewState = createEditorViewState_1.default(userOptions.SignatureHtml /*content*/, false /*isDirty*/);
    optionState.signNewMails = null;
    optionState.signReplies = null;
}));
//# sourceMappingURL=discardSignatureOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/actions/discardSignatureOption.js
// module id = 5012
// module chunks = 2